// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"o6-z","colorTextValue":"p6-z","swatches":"q6-z","collapseLink":"r6-z","isCollapsed":"s6-z","dropdown":"t6-z","disabled":"u6-z"};